import { AUTH_USER_CLIENT } from '../graphql-client/queries';

const resolvers = {
  Mutation: {
    login: (_, { email, password }, { cache }) => {
      const input = {
        auth: {
          email,
          password,
          __typename: 'auth',
        },
      };

      cache.writeQuery({
        query: AUTH_USER_CLIENT,
        data: { authUser: input },
      });
      return input;
    },
  },
};
const defaults = {
  Auth: {
    __typename: 'auth',
    email: null,
    password: null,
  },
};
export default { resolvers, defaults };
